import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { useContext } from 'react';
import { URL, ATHENA_DASHBOARD_RESOURCES } from '../../helper';
import useService from '../../useService';
import { Action, ActionHandlerParams } from '../types';
import { AthenaCrudAction } from '../models';

export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog, setForceUpdateRows } = params;
	const { showAlert } = useContext(AppContext);
	const { approveAthenaCrudRequest, rejectAthenaCrudRequest } = useService();

	switch (action.id) {
		case AthenaCrudAction.VIEW: {
			return () => {
				history.push({
					pathname: `${URL[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]}/view`,
					state: {
						rowData
					}
				});
			};
		}
		case AthenaCrudAction.APPROVE: {
			const approveRequest = async () => {
				await approveAthenaCrudRequest(rowData, showAlert);
				setForceUpdateRows(true);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Are you sure you want to approve? After approval this request will go to athena_query_store',
					handleAlertConfirmation: approveRequest
				});
			};
		}
		case AthenaCrudAction.REJECT: {
			const rejectRequest = async () => {
				await rejectAthenaCrudRequest(rowData, showAlert);
				setForceUpdateRows(true);
			};
			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Are you sure you want to reject?',
					handleAlertConfirmation: rejectRequest
				});
			};
		}
		case AthenaCrudAction.EDIT: {
			return () => {
				history.push({
					pathname: `${URL[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]}/edit`,
					state: {
						rowData
					}
				});
			};
		}
		case AthenaCrudAction.VERSION_HISTORY: {
			return () => {
				history.push({
					pathname: `${URL[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]}/versionHistory`,
					state: {
						rowData
					}
				});
			};
		}
		case AthenaCrudAction.ADD:
			return () => {
				history.push({
					pathname: `${URL[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]}/create`
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
